import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["conditionsList", "emptyState"]

  connect() {
    this.toggleEmptyState()
    this.refreshAllRows()
    this.updateAndBadges()
  }

  afterAdd() {
    this.toggleEmptyState()
    this.refreshAllRows()
    this.updateAndBadges()
  }

  afterRemove() {
    this.toggleEmptyState()
    this.refreshAllRows()
    this.updateAndBadges()
  }

  toggleEmptyState() {
    if (!this.hasEmptyStateTarget || !this.hasConditionsListTarget) return

    const visibleItems = Array.from(
      this.conditionsListTarget.querySelectorAll("[data-condition-row]")
    ).filter((item) => {
      const hiddenByClass = item.classList.contains("hidden")
      const hiddenByStyle = getComputedStyle(item).display === "none"
      return !(hiddenByClass || hiddenByStyle)
    })

    this.emptyStateTarget.classList.toggle("hidden", visibleItems.length > 0)
  }

  refreshAllRows() {
    if (!this.hasConditionsListTarget) return

    this.conditionsListTarget
      .querySelectorAll("[data-condition-row]")
      .forEach((row) => {
        const controller = this.application.getControllerForElementAndIdentifier(
          row,
          "campaign-condition-row"
        )
        controller?.refresh()
      })
  }

  updateAndBadges() {
    if (!this.hasConditionsListTarget) return

    const rows = Array.from(this.conditionsListTarget.querySelectorAll("[data-condition-row]"))
      .filter((row) => {
        const hiddenByClass = row.classList.contains("hidden")
        const hiddenByStyle = getComputedStyle(row).display === "none"
        return !(hiddenByClass || hiddenByStyle)
      })

    this.conditionsListTarget
      .querySelectorAll("[data-condition-and]")
      .forEach((badge) => badge.remove())

    rows.forEach((row, index) => {
      if (index === 0) return
      row.insertAdjacentHTML(
        "beforebegin",
        '<div class="pill-sm pill:gray w-fit mx-auto" data-condition-and>AND</div>'
      )
    })
  }
}
